import { useMutation } from '@tanstack/react-query'
import { billingApi } from '../../utils/api'

/**
 * サブスク決済チェックアウト作成（BillingPage）。
 * 成功時は現行どおり外部決済ページへ遷移する。
 */
export function useCreateCheckout() {
  return useMutation({
    mutationFn: (planType: string) => billingApi.createCheckout(planType),
    onSuccess: (data: { url: string }) => {
      window.location.href = data.url
    },
  })
}
